import { render, staticRenderFns } from "./LTableHead.vue?vue&type=template&id=c3a63536"
import script from "./LTableHead.vue?vue&type=script&lang=js"
export * from "./LTableHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports